import { db } from "@/config/firebaseConfig";
import { removeUndefinedProperties } from "@/lib/utils";
import { useQuery } from "@tanstack/react-query";
import {
  collection,
  getDocs,
  limit as limitConstraint,
  orderBy as orberByConstraint,
  query,
  where,
} from "firebase/firestore";
import { TopLevelReciprocalMatch, ReviewStatus } from "@/types/topLevelReciprocalMatch";

type BaseProps = {
  limit?: number;
  orderBy?: "asc" | "desc";
  reviewStatus?: ReviewStatus;
};

// type AtLeastOneId<T> = Partial<T> &
//   { [K in keyof T]: Required<Pick<T, K>> }[keyof T];

type AtLeastOneId =
  | { jobAdId: string; businessId?: string; candidateId?: string }
  | { businessId: string; jobAdId?: string; candidateId?: string }
  | { candidateId: string; jobAdId?: string; businessId?: string };

export default function useTopLevelReciprocalMatches(
  props: BaseProps & AtLeastOneId
) {
  const { jobAdId, businessId, candidateId, limit, orderBy, reviewStatus } = props;

  const queryKey = [
    "topLevelReciprocalMatches",
    removeUndefinedProperties(props),
  ];

  return useQuery({
    queryKey,
    queryFn: async () => {
      try {
        const collectionRef = collection(db, "TopLevelReciprocalMatches");

        const queryConstraints: any = [
          jobAdId && where("jobAdId", "==", jobAdId),
          businessId && where("businessId", "==", businessId),
          candidateId && where("candidateId", "==", candidateId),
          reviewStatus && where("reviewStatus", "==", reviewStatus),
          orderBy && orberByConstraint("timestamp", orderBy),
          limit && limitConstraint(limit),
        ].filter(Boolean); // Remove falsy values

        const querySnapshot = await getDocs(
          query(collectionRef, ...queryConstraints)
        );

        const matches = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as TopLevelReciprocalMatch[];
        return matches;
      } catch (error) {
        console.error("useTopLevelReciprocalMatches error", error);
        throw new Error("useTopLevelReciprocalMatches error");
      }
    },
  });
}
